import { render, staticRenderFns } from "./PostPartDescriptionForm.vue?vue&type=template&id=39cce0f6&"
import script from "./PostPartDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./PostPartDescriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports